import { Row, Col, Button, notification, Divider, Pagination, Spin, Empty } from "antd";
import { EditOutlined, DeleteOutlined, SendOutlined, ReloadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import axios from "axios";

import endpoints from "../../utils/endpoints";

import "./Faqs.css";
import dayjs from "dayjs";
import config from "../../utils/config";

function Faqs() {
  const [isLoading, setIsLoading] = useState(true);

  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(10);

  useEffect(() => {
    handleGetData();
  }, []);

  function handleGetData() {
    setIsLoading(true);
    axios
      .get(endpoints.faq.read)
      .then((res) => {
        setTableData(res.data);
        setData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function handleChangePage(e, p) {
    setCurrentPage(e);
    setItemsPerPage(p);
    if (e <= 1) {
      setMinValue(0);
      setMaxValue(p);
    } else {
      let newMinValue = p * (e - 1);
      let newMaxValue = newMinValue + p;
      setMinValue(newMinValue);
      setMaxValue(newMaxValue);
    }
  }

  return (
    <div className="dashboard_page">
      <Row className="title_row mb-20 dashboard_title_row">
        <Col span={12} className="d-flex jc-start ai-center">
          <h3 className="mt-0 mb-0">FAQs</h3>
        </Col>
        <Col span={12} className="d-flex jc-end ai-center">
          <Button size="large" onClick={handleGetData} className="mr-10">
            <ReloadOutlined />
          </Button>
        </Col>
      </Row>
      <Divider />
      <Spin spinning={isLoading}>
        <Row className="dashboard_content_row">
          <Col xs="24" xl={24}>
            {tableData.length > 0 ? (
              <div className="d-flex flex-column jc-sb h-100">
                <div>
                  {tableData.slice(minValue, maxValue).map((item) => {
                    return (
                      <Row className="program_item" key={item.id}>
                        <Col span={24}>
                          <Row gutter={[24]}>
                            <Col span={7}>
                              <div className="d-flex flex-column">
                                <span className="f-12">Nome</span>
                                <span className="f-18 semi-bold">{item.name}</span>
                              </div>
                            </Col>
                            <Col span={7} className="d-flex jc-start ai-center">
                              <div className="d-flex flex-column">
                                <span className="f-12">E-mail</span>
                                <span className="d-flex ai-center">{item.email}</span>
                              </div>
                            </Col>
                            <Col span={8} className="d-flex jc-start ai-center">
                              <div className="d-flex flex-column">
                                <span className="f-12">Texto</span>
                                <span className="d-flex ai-center">{item.text}</span>
                              </div>
                            </Col>
                            <Col span={2} className="d-flex jc-end ai-center">
                              {item.actions}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                </div>
                <div className="d-flex jc-center ai-center">
                  <Pagination onChange={handleChangePage} pageSize={itemsPerPage} defaultCurrent={1} current={currentPage} total={tableData.length} />
                </div>
              </div>
            ) : (
              <Row className="d-flex jc-center ai-center empty_data">
                <Col span={24} className="d-flex flex-column jc-center ai-center">
                  <Empty description="Sem dados a apresentar" />
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Spin>
    </div>
  );
}

export default Faqs;
